module.exports = __webpack_public_path__ + "img/aa@2x.44a65aeb.png";